import Text from 'components/base/Text';
import { StyledCell, StyledBlankTrendIcon } from './Cells.style';
import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import CellTooltip from './CellToolTip';
import { getShouldShowTrend } from '../../../GroupMetricsTable.service';

const TableCell = ({
  value,
  previuosValue,
  isHovered = false,
  trendIconName,
  trendIconColor = 'catskillWhite',
  trendDirection = '',
  tooltipTitle,
  percentChange,
  lastPeriodDates
}) => {
  const shouldShowTrend = getShouldShowTrend(
    value,
    trendIconName,
    previuosValue,
    lastPeriodDates
  );

  return (
    <Flex>
      <StyledCell>
        <Text size='medium' color='shuttleGray'>
          {value}
        </Text>
      </StyledCell>
      {shouldShowTrend ? (
        <Tooltip
          title={
            <CellTooltip
              title={tooltipTitle}
              directionColor={trendIconColor}
              previuosValueFormatted={previuosValue}
              trendDirection={trendDirection}
              percentChange={percentChange}
              lastPeriodDates={lastPeriodDates}
            />
          }
        >
          <Flex items='center' pl='0.8rem'>
            <Icon name={trendIconName} color={trendIconColor} />
          </Flex>
        </Tooltip>
      ) : (
        <StyledBlankTrendIcon paddingLeft='0.8rem' />
      )}
    </Flex>
  );
};
export default TableCell;
